import { render } from "./SnackbarFeedback.vue?vue&type=template&id=e0c60e6c"
import script from "./SnackbarFeedback.vue?vue&type=script&lang=js"
export * from "./SnackbarFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__